import { ChangeDetectorRef, Component, Input, OnInit } from "@angular/core";
import {
  GraphicsInfoMediaField,
  GraphicsInfoMediaType,
  MediaType,
} from "../../../../domain/graphics-info";
import { MediaRepository } from "../../../../domain/media-repository";
import { MediaInfo, MediaItem } from "../../../../domain/media";

@Component({
  selector: "icn-graphics-media-item",
  templateUrl: "./media-item.component.html",
  styleUrls: ["./media-item.component.scss"],
  host: {
    "[class.is-current]": "isCurrent",
  },
})
export class GraphicsMediaItemComponent implements OnInit {
  constructor(
    private mediaRepository: MediaRepository,
    private changeDetectorRef: ChangeDetectorRef,
  ) {}

  @Input() media: GraphicsInfoMediaField;
  @Input() isCurrent: boolean;

  dynamicIcon = "/assets/icons/dynamic-icon.svg";
  linkIcon = "/assets/icons/link-icon.svg";

  mediaInfo: MediaInfo;
  onDrag = false;

  ngOnInit() {
    this.setMediaInfo();
  }

  mediaChanged(editedMedia: GraphicsInfoMediaField) {
    this.media = editedMedia;
    this.changeDetectorRef.markForCheck();
  }

  setMediaInfo() {
    if (this.media.mediaId == null) return;
    this.mediaRepository.getMediaInfo(this.media.mediaId).then((result) => {
      this.mediaInfo = result;
      this.changeDetectorRef.markForCheck();
    });
  }

  onDrop(event: DragEvent) {
    this.onDrag = false;
    if (!event.dataTransfer.getData("text/media")) {
      return;
    }
    let draggedMedia: MediaItem = JSON.parse(
      event.dataTransfer.getData("text/media"),
    );
    if (!draggedMedia) return;
    this.media.mediaId = draggedMedia.id;
    this.media.mediaType = GraphicsInfoMediaType.MediaId;
    this.media.dynamic = null;
    this.media.link = null;
    this.media.imageOrVideo =
      draggedMedia.contentMediaType === 3 ? MediaType.Image : MediaType.Video;
    this.setMediaInfo();
    this.changeDetectorRef.markForCheck();
  }

  onDynamicClick() {
    this.media.link = null;
    this.media.mediaId = null;
    this.mediaInfo = null;
    this.media.mediaType = GraphicsInfoMediaType.DynamicOption;
    this.changeDetectorRef.markForCheck();
  }

  onLinkClick() {
    this.media.dynamic = null;
    this.media.mediaId = null;
    this.mediaInfo = null;
    this.media.mediaType = GraphicsInfoMediaType.Link;
    this.changeDetectorRef.markForCheck();
  }

  removeMedia() {
    this.media.mediaId = null;
    this.media.dynamic = null;
    this.media.link = null;
    this.mediaInfo = null;
    this.media.mediaType = GraphicsInfoMediaType.None;
    this.changeDetectorRef.markForCheck();
  }

  isVideo() {
    switch (this.media.mediaType) {
      case GraphicsInfoMediaType.None:
      case GraphicsInfoMediaType.Link:
        return false;
      case GraphicsInfoMediaType.MediaId:
        return (
          this.mediaInfo &&
          (this.mediaInfo.contentMediaType === 0 ||
            this.mediaInfo.contentMediaType === 1)
        );
    }
    return false;
  }

  isImage() {
    switch (this.media.mediaType) {
      case GraphicsInfoMediaType.None:
      case GraphicsInfoMediaType.Link:
        return false;
      case GraphicsInfoMediaType.MediaId:
        return this.mediaInfo && this.mediaInfo.contentMediaType === 3;
    }
    return false;
  }

  onDragOver(dragEvent: DragEvent) {
    if (dragEvent.dataTransfer.types.indexOf("text/media") !== -1) {
      dragEvent.preventDefault();
    }
  }

  onDragEnter() {
    this.onDrag = true;
  }

  onDragLeave() {
    this.onDrag = false;
  }
}
